import { useContext, useEffect, useState } from "react";
import "../css/settings/settings.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Signout from "./Signout/Signout";
import { AuthContext } from "./SessionChecker/SessionChecker";

function Settings({ theme, setTheme }) {
  const [ANM, setANM] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [openSignout, setOpenSignout] = useState(false);

  const { sessionStatus } = useContext(AuthContext);

  useEffect(() => {
    document.title = t("Hiket, Settings");
    theme === "light" ? setANM(false) : setANM(true);
  }, []);

  return (
    <div className="main_div">
      <div className="scroll_div">
        <button
          className={`menuButton ${theme}`}
          onClick={() => {
            setTheme(theme === "light" ? "night" : "light");
            setANM(!ANM);
          }}
        >
          <img src="/icons/moon.png" className={`icon ${theme}`}></img>
          <div>{t("Night mode")}</div>
          <div className="center_div"></div>
          <div className={`activation_div`}>
            <div
              className={`activation_icon ${theme === "night" ? "active" : ""} ${ANM ? "active" : ""}`}
            ></div>
          </div>
        </button>

        <button
          className={`menuButton ${theme}`}
          onClick={() => {
            navigate("/languages/");
          }}
        >
          <img src="/icons/languages.png" className={`icon ${theme}`}></img>
          <div>{t("Language")}</div>
          <div className="center_div"></div>
        </button>

        {sessionStatus && (
          <>
            {" "}
            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                navigate("/sessions/");
              }}
            >
              <img src="/icons/devices.png" className={`icon ${theme}`}></img>
              <div>{t("Sessions")}</div>
            </button>
            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                navigate("/edit_profile/");
              }}
            >
              <img src="/icons/profile.png" className={`icon ${theme}`}></img>
              <div>{t("Edit profile")}</div>
            </button>
            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                navigate("/authentication/");
              }}
            >
              <img
                src="/icons/authentication.png"
                className={`icon ${theme}`}
              ></img>
              <div>{t("Authentication")}</div>
            </button>
            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                setOpenSignout(true);
              }}
            >
              <img src="/icons/signout.png"></img>
              <div>{t("Signout")}</div>
            </button>{" "}
          </>
        )}

        {openSignout && (
          <Signout
            theme={theme}
            onClose={() => {
              setOpenSignout(false);
            }}
          ></Signout>
        )}
      </div>
    </div>
  );
}

export default Settings;
